export default "__VITE_ASSET__DANvx8ZE__"